import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';
import canvaListMixin from '../../mixins/_canva_list';

/** おすすめキーワード定義 */
const RECOMMEND_KEYWORDS = [
    'バレンタイン',
    'ホワイトデー',
    '新生活',
    '送料無料',
    '看板'
];

/**
 * テンプレートリストのコンポーネント
 */
export default {
    name: 'templateList',
    template: '#template_list_template',
    props: {
        recommend_keywords: {
            type: Array,
            require: true,
        }
    },
    components: {
        // サイズ毎のテンプレートリスト
        'templates-item': {
            name: 'templatesItem',
            template: '#templates_item_template',
            data() {
                return {
                    // テンプレートリスト
                    templates: []
                };
            },
            props: {
                prop_templates: {
                    type: Array,
                    require: true,
                    default: function() {
                        return [];
                    }
                },
                selected_design: {
                    type: String,
                    require: true,
                    default: ''
                },
                selected_size: {
                    type: String,
                    require: true,
                    default: ''
                }
            },
            watch: {
                // 全カテゴリが更新された時 or 読み込み時
                prop_templates: {
                    handler(val) {
                        this.templates = val;
                    },
                    immediate: true,
                }
            },
            computed: {
                is_open: function () {
                    return (this.selected_size !== null || this.selected_design !== '');
                }
            },
            emits: ['emit_design'],
            methods: {
                // 確認モーダルを開く
                modalOpenCanva: function(url) {
                    this.$parent.$refs.modalOpenCanva.show(url);
                },
                // 画像のフルパスを返却する
                getFullImagePath: function(imagePath) {
                    return this.$parent.config.storage_path + '/' + imagePath;
                },
                emitDesign: function (design) {
                    this.$emit('emit_design', design);
                }
            }
        },
        // 確認モーダル
        'modal-open-canva': {
            template: '#modal_open_canva_template',
            data() {
                return {
                    // canvaの共有URL
                    url: null
                };
            },
            mixins: [modalMixin],
            methods: {
                // 確認モーダルを開く
                show: function(url) {
                    this.url = url;
                    this.open();
                }
            }
        }
    },
    mixins: [commonMixin, flashMessageMixin, modalMixin, canvaListMixin],
    created: function() {
        this.getTemplateList();
    },
    methods: {
        // おすすめキーワードからの検索
        searchTemplatesByKeywordClick: function(keyword) {
            this.input_keyword = keyword;
            this.getTemplateList();
        },
    }
};
